module.exports = __webpack_public_path__ + "img/no_data.729fd8c9.png";